/**
 * Cliente HTTP revisión Guiones IA (COMERCIAL) — api-rh.
 * Auth: headers de sesión ERP (user-id / Authorization) vía axios interceptors.
 */
import axios from 'axios'

export function listarGuiones(params) {
  return axios.get('guion.ia.listar', { params: params || {} })
}

export function generarGuion(payload) {
  return axios.post('guion.ia.generar', payload || {})
}

export function editarGuion(payload) {
  return axios.put('guion.ia.editar', payload || {})
}

export function aprobarGuion(id) {
  return axios.post('guion.ia.aprobar', { id })
}

export function rechazarGuion(id, motivo_rechazo) {
  return axios.post('guion.ia.rechazar', { id, motivo_rechazo })
}

export function listarDudas(params) {
  return axios.get('guion.ia.dudas.listar', { params: params || {} })
}

export function editarDuda(payload) {
  return axios.put('guion.ia.dudas.editar', payload || {})
}

export function aprobarDuda(id) {
  return axios.post('guion.ia.dudas.aprobar', { id })
}

export function rechazarDuda(id) {
  return axios.post('guion.ia.dudas.rechazar', { id })
}

export function listarConversaciones(params) {
  return axios.get('guion.ia.conversaciones.listar', { params: params || {} })
}

export function obtenerConversacion(id) {
  return axios.get(`guion.ia.conversaciones/${id}`)
}

export function revisarConversacion(payload) {
  return axios.put('guion.ia.conversaciones.revisar', payload || {})
}

export function resumenRetroalimentacion(params) {
  return axios.get('guion.ia.retroalimentacion.resumen', { params: params || {} })
}

export function listarRetroalimentaciones(params) {
  return axios.get('guion.ia.retroalimentacion.listar', { params: params || {} })
}

export function listarPruebasIa(params) {
  return axios.get('guion.ia.pruebas.listar', { params: params || {} })
}

export default {
  listarGuiones,
  generarGuion,
  editarGuion,
  aprobarGuion,
  rechazarGuion,
  listarDudas,
  editarDuda,
  aprobarDuda,
  rechazarDuda,
  listarConversaciones,
  obtenerConversacion,
  revisarConversacion,
  resumenRetroalimentacion,
  listarRetroalimentaciones,
  listarPruebasIa,
}
